import { render } from "./TableRow.vue?vue&type=template&id=dc5e21a2"
import script from "./TableRow.vue?vue&type=script&lang=js"
export * from "./TableRow.vue?vue&type=script&lang=js"

import "./TableRow.vue?vue&type=style&index=0&id=dc5e21a2&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__